import {
  PageContainer,
  PageContent,
  PageFooterBar,
} from "../../components/PageContainer";
import _ from "lodash";
import { BreadCrumbs, TitleBar } from "../../components/TitleBar";
import { BackButton, SaveButton } from "../../components/Button";
import { useParams } from "react-router";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router";
import apiAgent from "../../api/apiAgent";
import { getDataAndSchemaFromModel } from "../../components/Forms/utils";
import { useAtomValue } from "jotai";
import { modelDataAtom, useValidateModel, userAtom } from "../../atoms";
import { tMsg } from "../../components/ToastNotifications";
import { checkTitle, useOriginParams } from "../../utils";
import BaseForm from "../../components/Forms/BaseForm";
import { useSetChangesMade } from "../../components/Publishing/utils";
import { useSearchParams } from "react-router-dom";
import {
  screenTypes,
  screenTypesArray,
} from "../../utils/slideTemplateAllocation";
import SlidesForm from "./form";
import { PreviewSelector } from "./previews";

const UpdateSlides = (): JSX.Element => {
  const params = useParams();
  const [originFrom, originId] = useOriginParams();
  const [searchParams] = useSearchParams();
  // const screenId = _.toNumber(searchParams.get("screenType") || -1);
  // const screenType = screenTypes[screenId as keyof typeof screenTypes];

  const userData = useAtomValue(userAtom);
  const modelData = useAtomValue(modelDataAtom);
  const modelName = "slides";
  const setChangesMade = useSetChangesMade(modelName);

  const navigate = useNavigate();
  const [itemData, setItemData] = useState<any>(null);
  const [schema, setSchema] = useState<any[]>([]);
  const [isLoadingData, setIsLoadingData] = useState<boolean>(true);
  const [isLoadingSchema, setIsLoadingSchema] = useState<boolean>(true);

  useEffect(() => {
    if (modelData && modelData !== null && isLoadingSchema) {
      const [, getSchema] = getDataAndSchemaFromModel(
        modelData,
        modelName,
        true
      );
      // we don't set item data for update
      setSchema(getSchema);
      setIsLoadingSchema(false);
    }
  }, [modelData]);

  useEffect(() => {
    fetchData();
  }, []);

  const fetchData = async () => {
    try {
      const response = await apiAgent.DataType.getAll(modelName);

      const { data } = response;
      const item =
        data.find((item: any) => _.toString(item.id) === params.id) || null;

      setItemData(item);
    } catch (err) {
      console.log(err);
    } finally {
      setIsLoadingData(false);
    }
  };

  const screenType = screenTypesArray.find(
    (screen) => screen.id === itemData?.screenType
  );
  const screenId = itemData?.screenType;
  const capitalizedName = `${screenType?.name} slide`;
  const crumbs = [
    {
      label: `${screenType?.name}`,
      link: `/m/${modelName}?screenType=${screenId}`,
    },
  ];

  const saveItem = async (screen_id: number) => {
    try {
      const data = {
        ...itemData,
        editedBy: userData?.id,
        targetIdx: itemData.id,
      };
      const response = await apiAgent.DataType.update(modelName, data);
      if (response.status === 200) {
        console.log("save response", response);
        tMsg.success(`Slide successfully updated`);
        setChangesMade();
        if (originFrom && originId)
          navigate(`/m/${originFrom}/show/${originId}?screenType=${screen_id}`);
        else
          navigate(
            `/m/${modelName}/show/${itemData.id}?screenType=${screen_id}`
          );
        // else navigate(`/m/${originFrom}/show/${originId}?screenType=${screenId}`)
      } else throw response.statusText;
    } catch (err) {
      tMsg.error(`Error changing slide`);
      console.log(err);
    }
  };

  return (
    <PageContainer
      isLoading={isLoadingData || isLoadingSchema}
      className="relative"
    >
      <PageContent reduceHeightForFooter>
        <BreadCrumbs crumbs={crumbs} />
        <TitleBar title={`Edit ${capitalizedName}`}>
          <BackButton />
        </TitleBar>
        <SlidesForm
          modelName={modelName}
          itemData={itemData}
          setItemData={setItemData}
          schema={schema}
          onSubmit={(e) => {
            e.preventDefault();
            saveItem(screenId);
          }}
        />
        <PreviewSelector screenType={screenId} itemData={itemData} />
      </PageContent>
      <PageFooterBar>
        <SaveButton />
      </PageFooterBar>
    </PageContainer>
  );
};

export default UpdateSlides;
